var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type === "float"
        ? _c("v-text-field", {
            directives: [
              {
                name: "money",
                rawName: "v-money",
                value: _vm.maskPercent,
                expression: "maskPercent"
              }
            ],
            staticClass: "ml-2",
            staticStyle: { "max-width": "140px" },
            attrs: {
              dense: "",
              rules: [_vm.rules.range],
              value: _vm.value,
              label: _vm.title
            },
            on: { change: _vm.teste }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }